export const NUMERO_QUANTIDADE_REGISTROS = ['5', '10', '20', '50', '100'];
